import MenuItem from './MenuItem'
import SocialMediaSvgs from './SocialMediaSvgs'

const MenuBar = () => {
    function fade(e) {
        e.currentTarget.classList.toggle('menu-active')
        document.querySelector('.menu-bar').classList.toggle('menu-bar-active')
        document.querySelector('.menu-button').classList.toggle('menu-button-active')
    }
    return (
        <>
            <div className='menu' onClick={fade}></div>
            <div className="menu-bar">
                <ul className='mb-3'>
                    <MenuItem names={['HOME', 'ABOUT', 'PROJECTS', 'CONTACT']} />
                </ul>
                <SocialMediaSvgs color="w"/>
            </div>
        </>

    )
}

export default MenuBar